import {
  WBBox,
  WBButton,
  WBFlex,
  WBIcon,
  WBTypography,
  WBView,
} from '@admiin-com/ds-web';
import { SearchClientInput } from '../../../../../../components/SearchClientInput/SearchClientInput';
import React, { useState } from 'react';
import { useSearchResults } from './hooks/useSearchResults';
import { EntityItem } from './components/EntityItem';
import { useFirmId } from '../../../../../../../hooks/useClientWorkflow/useClientWorkflow';
import { useModal } from '../../../../../../components/ModalManager/ModalContext';
export const SearchEntityMobile = ({ onClick }: { onClick: () => void }) => {
  const [query, setQuery] = useState('');
  const { openModal } = useModal();
  const { loading, onChange, options } = useSearchResults({
    query,
    limit: 10,
  });
  const { isFirm } = useFirmId();

  return (
    <WBView gap={2}>
      <WBFlex flexDirection="row" flex={1}>
        <WBBox flexGrow={1}>
          <SearchClientInput value={query} onChange={setQuery} />
        </WBBox>
        <WBButton
          sx={{ ml: 1 }}
          onClick={() => openModal(isFirm ? 'clientCreate' : 'entityCreate')}
        >
          <WBIcon name="Add" color="inherit" size="small" />
          <WBTypography
            variant="inherit"
            fontWeight="bold"
            noWrap
            color={'light'}
            display={{ xs: 'none', sm: 'block' }}
          >
            {isFirm ? 'New Client' : 'New Entity'}
          </WBTypography>
        </WBButton>
      </WBFlex>

      {loading && (
        <WBView>
          <WBTypography variant="h4">Loading...</WBTypography>
        </WBView>
      )}
      {options &&
        options.map((entity) => (
          <EntityItem
            key={entity.id}
            entity={entity}
            onClick={() => {
              onChange(null, entity);
              onClick();
            }}
          />
        ))}
      {!loading && options && options.length === 0 && (
        <WBView>
          <WBTypography variant="h4">No results found</WBTypography>
        </WBView>
      )}
    </WBView>
  );
};
